import {
  Linkedin,
  Instagram,
  Facebook,
  Shield,
  Award,
  Heart,
  Clock,
  AlertTriangle,
  CheckCircle,
  Users,
  ShieldCheck,
  AlertCircle,
  Zap,
  Wind,
  Navigation,
  Flame,
  Wrench,
  Search,
  Settings,
  Sparkles,
} from "lucide-react";

export const FooterLinks = [
  {
    title: "Company",
    links: [
      { name: "Home", path: "/home" },
      // {/* temp comment */}
      // // { name: "About us", path: "/about-us" },
      { name: "Services", path: "/services" },
      { name: "Service Area", path: "/service-area" },
      { name: "Safety", path: "/safety" },
    ],
  },
];

export const SocialLinks = [
  {
    name: "Facebook",
    icon: <Facebook />,
    url: "https://facebook.com/m2gasservices", // Replace with your actual URL
  },
  {
    name: "Instagram",
    icon: <Instagram />,
    url: "https://instagram.com/m2gasservices", // Replace with your actual URL
  },
  {
    name: "Linkedin",
    icon: <Linkedin />,
    url: "https://linkedin.com/company/m2gasservices", // Replace with your actual URL
  },
];

export const GalleryItems = [
  {
    id: 1,
    image:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80",
    title: "Modern Living Room Fireplace",
    category: "Residential",
    description:
      "Contemporary gas fireplace installation with custom stone surround",
  },
  {
    id: 2,
    image:
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80",
    title: "Outdoor Patio Fire Feature",
    category: "Residential",
    description: "Custom outdoor gas fire pit with safety controls",
  },
  {
    id: 3,
    image:
      "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&q=80",
    title: "Commercial Kitchen Gas Lines",
    category: "Commercial",
    description:
      "Restaurant-grade gas line installation for professional kitchen",
  },
  {
    id: 4,
    image:
      "https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800&q=80",
    title: "Master Bedroom Fireplace",
    category: "Residential",
    description:
      "Luxury gas fireplace with remote control and ambient lighting",
  },
  {
    id: 5,
    image:
      "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800&q=80",
    title: "Double-Sided Fireplace",
    category: "Residential",
    description: "See-through gas fireplace between living and dining areas",
  },
  {
    id: 6,
    image:
      "https://images.unsplash.com/photo-1600210492493-0946911123ea?w=800&q=80",
    title: "Commercial Building Gas System",
    category: "Commercial",
    description: "Complete gas line infrastructure for multi-unit building",
  },
];

export const Testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    location: "Mooresville, NC",
    rating: 5,
    text: "Michael and his team did an outstanding job installing our new gas fireplace. They were professional, punctual, and the quality of work exceeded our expectations. The fireplace has become the centerpiece of our living room!",
    date: "2 weeks ago",
  },
  {
    id: 2,
    name: "Mike Thompson",
    location: "Charlotte, NC",
    rating: 5,
    text: "Excellent work on our whole-home gas line upgrade. They were thorough, professional, and ensured everything was up to code. The pricing was fair and the communication throughout the project was outstanding.",
    date: "1 month ago",
  },
  {
    id: 3,
    name: "Jennifer Davis",
    location: "Huntersville, NC",
    rating: 5,
    text: "We needed gas lines run for our new outdoor kitchen and fire pit. The work was completed on time, within budget, and passed inspection without any issues. True professionals!",
    date: "3 weeks ago",
  },
  {
    id: 4,
    name: "Robert Chen",
    location: "Cornelius, NC",
    rating: 5,
    text: "Fantastic service from start to finish. They helped us choose the right fireplace for our space and the installation was flawless. Very knowledgeable about local codes and safety requirements.",
    date: "1 week ago",
  },
  {
    id: 5,
    name: "Amanda Rodriguez",
    location: "Davidson, NC",
    rating: 5,
    text: "Had them install gas lines for our new water heater and stove. Clean work, fair pricing, and they cleaned up everything when finished. Will definitely use them again for future projects.",
    date: "2 months ago",
  },
  {
    id: 6,
    name: "David Wilson",
    location: "Mooresville, NC",
    rating: 5,
    text: "Converted our old wood-burning fireplace to gas. The transformation is amazing and now we can enjoy it with just the touch of a button. Highly recommend their expertise and customer service!",
    date: "3 weeks ago",
  },
];

export const TeamMembers = [
  {
    name: "Team Member 1",
    role: "Lead Gas Technician",
    image:
      "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop",
  },
  {
    name: "Team Member 2",
    role: "Gas Line Specialist",
    image:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop",
  },
];

export const Values = [
  {
    icon: Shield,
    title: "Safety First",
    description:
      "Every job is completed with meticulous attention to safety standards and code compliance.",
  },
  {
    icon: Award,
    title: "Expert Craftsmanship",
    description:
      "Decades of combined experience delivering quality gas line installations and repairs.",
  },
  {
    icon: Heart,
    title: "Customer Focused",
    description:
      "Your satisfaction and peace of mind are at the heart of everything we do.",
  },
  {
    icon: Clock,
    title: "Reliable Service",
    description:
      "On-time appointments, honest quotes, and work completed right the first time.",
  },
];

export const Stats = [
  { number: "15+", label: "Years Experience" },
  { number: "500+", label: "Projects Completed" },
  { number: "100%", label: "Licensed & Insured" },
  { number: "5-Star", label: "Customer Rating" },
];

export const ServiceTypes = [
  "Gas Line Installation",
  "Gas Line Repair",
  "Leak Detection",
  "Appliance Hookups",
  "Maintenance & Inspection",
  "Other",
];

export const TimeSlots = [
  "8:00 AM - 10:00 AM",
  "10:00 AM - 12:00 PM",
  "12:00 PM - 2:00 PM",
  "2:00 PM - 4:00 PM",
  "4:00 PM - 6:00 PM",
  "Flexible",
];

export const PreventionTips = [
  {
    icon: Clock,
    title: "Regular Maintenance",
    description:
      "Schedule annual maintenance checks to ensure your gas systems are operating safely and efficiently.",
  },
  {
    icon: CheckCircle,
    title: "Proper Ventilation",
    description:
      "Keep gas appliances well-ventilated to prevent carbon monoxide buildup and ensure proper combustion.",
  },
  {
    icon: ShieldCheck,
    title: "Install Detectors",
    description:
      "Install carbon monoxide and natural gas detectors near gas appliances and sleeping areas.",
  },
  {
    icon: Wind,
    title: "Clear Venting",
    description:
      "Ensure outdoor vents are clear of debris, snow, and vegetation for proper exhaust flow.",
  },
  {
    icon: AlertCircle,
    title: "Know the Signs",
    description:
      "Learn to recognize warning signs like unusual odors, hissing sounds, or dead vegetation near lines.",
  },
  {
    icon: Zap,
    title: "Professional Work Only",
    description:
      "Never attempt DIY gas line repairs or modifications. Always hire licensed professionals.",
  },
];

export const TrustBadges = [
  { icon: Award, text: "Certified Technicians", subtext: "Ongoing Training" },
  {
    icon: ShieldCheck,
    text: "Quality Equipment",
    subtext: "Industry Standard",
  },
  { icon: Users, text: "Safety Inspections", subtext: "Regular Checks" },
];

export const WarningSign = [
  {
    icon: AlertTriangle,
    text: "Rotten egg smell (added to natural gas)",
    color: "text-orange-400",
  },
  {
    icon: AlertTriangle,
    text: "Hissing or whistling sounds near gas lines",
    color: "text-orange-400",
  },
  {
    icon: AlertTriangle,
    text: "Dead or dying vegetation near gas lines",
    color: "text-orange-400",
  },
  {
    icon: AlertTriangle,
    text: "Bubbles in standing water",
    color: "text-orange-400",
  },
];

export const ServicedCounties = [
  "Iredell County",
  "Mecklenburg County",
  "Cabarrus County",
  "Rowan County",
  "Catawba County",
  "Lincoln County",
  "Gaston County",
  "Union County",
];

export const ServiceFeatures = [
  {
    icon: Clock,
    title: "Fast Response Times",
    description: "We prioritize quick response throughout our service area",
  },
  {
    icon: CheckCircle,
    title: "Local Expertise",
    description:
      "Familiar with local codes and regulations in every county we serve",
  },
  {
    icon: Navigation,
    title: "Reliable Coverage",
    description: "Consistent, professional service across all serviced areas",
  },
];

export const ServiceDefinitions = [
  {
    icon: Flame,
    title: "Gas Line Installation",
    description:
      "Professional installation of new gas lines for homes and businesses. We ensure safe, efficient setups compliant with all local codes.",
    featured: false,
  },
  {
    icon: Wrench,
    title: "Gas Line Repair",
    description:
      "Expert repairs for damaged or aging gas lines. Quick diagnosis and fixes to restore safe operation and prevent hazards.",
    featured: false,
  },
  {
    icon: Search,
    title: "Leak Detection",
    description:
      "Advanced detection services to identify and locate gas leaks. Using state-of-the-art equipment for accurate, non-invasive inspections.",
    featured: false,
  },
  {
    icon: Settings,
    title: "Appliance Hookups",
    description:
      "Safe connection of gas appliances including stoves, water heaters, and fireplaces. Proper installation for optimal performance and safety.",
    featured: false,
  },
  {
    icon: ShieldCheck,
    title: "Maintenance & Inspections",
    description:
      "Regular maintenance and thorough inspections to keep your gas systems running efficiently and safely year-round.",
    featured: false,
  },
  {
    icon: Sparkles,
    title: "Fireplace Services",
    description:
      "Complete fireplace installation, repair, and maintenance. Transform your home with beautiful, efficient gas fireplaces.",
    featured: false,
  },
];

export const NavLinks = [
  { name: "Home", href: "/" },
  { name: "Services", href: "/services" },
  { name: "Service Area", href: "/service-area" },
  { name: "Safety", href: "/safety" }
  // temp comment
  // { name: "About Us", href: "/about-us" },
];
